import React from "react";

import { Stack, CircularProgress, Box } from "@mui/material";
import { Typography } from "components";
import { colors } from "configs";

interface LoadingOverlayProps {
  loading?: boolean;
  label?: string;
  noPadding?: boolean;
  noBgColor?: boolean;
  value?: number;
  children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading = false,
  label,
  noPadding = false,
  noBgColor = false,
  value,
  children,
}) => {
  return (
    <Stack
      position="relative"
      padding={noPadding ? 0 : "20px"}
      bgcolor={noBgColor ? "unset" : colors.gray[50]}
      borderRadius="12px"
    >
      {label && (
        <Stack mb="12px">
          <Typography type="TextLG" fontWeight={600}>
            {label}
          </Typography>
        </Stack>
      )}
      {loading && (
        <Stack
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={200}
          justifyContent="center"
          alignItems="center"
          borderRadius="12px"
          bgcolor="rgba(249, 250, 251, 0.5)"
        >
          <CircularProgress
            color="primary"
            variant={value ? "determinate" : "indeterminate"}
            value={value}
          />
          {!!value && (
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="caption"
                component="div"
                fontWeight={600}
                color="text.secondary"
              >{`${Math.round(value)}%`}</Typography>
            </Box>
          )}
        </Stack>
      )}
      {children}
    </Stack>
  );
};

export default LoadingOverlay;
